<template>
    <div class="main-container">
        <div class="Brandhistory" >
           <iframe id="ifra" scrolling="auto" width="100%" height="100%" src="../../static/Brand_history/document.html" frameborder="0"></iframe>
        </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {
          detailheight:''
      }
    },
    methods: {
        changeFrameHeight(){
            // var frame = document.getElementById('ifra')
            //   window.addEventListener('message', function(e) {
            //     console.log(e)
            //       frame.style.height = e.data.height + 'px'
            //       frame.style.width = e.data.width + 'px'
            //   })

            setTimeout(() => {
                            var ifm= document.getElementById("ifra");
                            var subWeb = document.frames ? document.frames["ifra"].document : ifm.contentDocument;    
            // iwin.scroll(0,doc.body.scrollHeight)
           document.body.scrollTop= subWeb.body.getElementsByClassName('history-scrollarea')[0].clientHeight
            }, 3000);
        }
   
    },
    mounted(){
      this.changeFrameHeight()
  }
  }
</script>
<style lang="less" scoped>

.Brandhistory{
    width: 100%;
    height: 100vh;
    .brad{
      width: 100%;
    }
    .brad::-webkit-scrollbar{
      display: none;
    }
}
</style>


// WEBPACK FOOTER //
// src/view/Brandhistory.vue